import { api } from "./api";

export const saveLogClube = async (nameBusiness,idStatus,token) => {
    try{
        const response = await api.post('/saveLogClube',
        {
          nameBusiness: nameBusiness,
          idStatus: idStatus
        },
        {
          headers: {
              token: token
          }
        })

        console.log(response.data);
    }
    catch(error){
        console.log(error)
    }
}
